import { wtsApi } from 'src/api';
import toastrError from 'src/helpers/toastr/toastrError';
import Utils from 'src/utils';
import dayjs from 'dayjs';
import { selectMainReportConfirmationLevels } from 'src/store/selectors/configurations';
import { loadConfigurationConfirmationLevels } from 'src/store/actions/configurationActions';
import { MainReport } from 'src/helpers/modular/mainReport/MainReportBuilder';
import { selectCompletedWorkData, selectWorkDays } from 'src/store/selectors/mainReportSelectors';
export var ActionTypes;
(function (ActionTypes) {
    ActionTypes["SAVE_MAIN_REPORT"] = "SAVE_MAIN_REPORT";
    ActionTypes["REQUEST_COMPLETED_WORK_CONFIRMATIONS"] = "REQUEST_COMPLETED_WORK_CONFIRMATIONS";
    ActionTypes["FAILED_COMPLETED_WORK_CONFIRMATIONS"] = "FAILED_COMPLETED_WORK_CONFIRMATIONS";
    ActionTypes["SAVE_NEW_COMPLETED_WORK_CONFIRMATION"] = "SAVE_NEW_COMPLETED_WORK_CONFIRMATION";
    ActionTypes["REMOVE_COMPLETED_WORK_CONFIRMATION"] = "REMOVE_COMPLETED_WORK_CONFIRMATION";
    ActionTypes["REQUEST_COMPLETED_WORK"] = "REQUEST_COMPLETED_WORK";
    ActionTypes["SAVE_COMPLETED_WORK"] = "SAVE_COMPLETED_WORK";
    ActionTypes["FAILED_COMPLETED_WORK"] = "FAILED_COMPLETED_WORK";
})(ActionTypes || (ActionTypes = {}));
export const requestCompletedWorkConfirmations = () => ({ type: ActionTypes.REQUEST_COMPLETED_WORK_CONFIRMATIONS });
export const failedCompletedWorkConfirmationsExtended = () => ({ type: ActionTypes.FAILED_COMPLETED_WORK_CONFIRMATIONS });
export const saveNewCompletedWorkConfirmationExtended = (confirmation) => ({ type: ActionTypes.SAVE_NEW_COMPLETED_WORK_CONFIRMATION, payload: confirmation });
export const removeCompletedWorkConfirmationExtended = (request, response) => ({ type: ActionTypes.REMOVE_COMPLETED_WORK_CONFIRMATION, payload: { request, response } });
export const requestCompletedWork = () => ({ type: ActionTypes.REQUEST_COMPLETED_WORK });
export const saveCompletedWork = (data) => ({ type: ActionTypes.SAVE_COMPLETED_WORK, payload: data });
export const failedCompletedWork = () => ({ type: ActionTypes.FAILED_COMPLETED_WORK });
export const saveMainReport = (data) => ({ type: ActionTypes.SAVE_MAIN_REPORT, payload: data });
export function setCompletedWorkConfirmation(params) {
    return (dispatch) => {
        dispatch(requestCompletedWorkConfirmations());
        return wtsApi.v2.completedWorkConfirmationSetCreate(params)
            .then((response) => {
            dispatch(saveNewCompletedWorkConfirmationExtended(response.data.Data));
        })
            .catch((e) => {
            toastrError(e);
            dispatch(failedCompletedWorkConfirmationsExtended());
            return Promise.reject(e);
        });
    };
}
export function removeCompletedWorkConfirmation(params) {
    return (dispatch) => {
        dispatch(requestCompletedWorkConfirmations());
        return wtsApi.v2.completedWorkConfirmationRemoveCreate(params)
            .then((response) => {
            dispatch(removeCompletedWorkConfirmationExtended(params, response.data.Data));
        })
            .catch((e) => {
            toastrError(e);
            dispatch(failedCompletedWorkConfirmationsExtended());
            return Promise.reject(e);
        });
    };
}
export function loadCompletedWork(params) {
    return (dispatch) => {
        dispatch(requestCompletedWork());
        return wtsApi.v2.completedWorkSearchMixedConfirmedCreate(params)
            .then((response) => {
            const data = response.data.Data;
            dispatch(saveCompletedWork(data));
            return data;
        })
            .catch((e) => {
            toastrError(e);
            dispatch(failedCompletedWork());
            return Promise.reject(e);
        });
    };
}
export function loadMainReport(params) {
    return async (dispatch, getState) => {
        try {
            dispatch(requestCompletedWork());
            const rawReportReq = dispatch(loadCompletedWork(params));
            const workDaysReq = wtsApi.workDays.workDaysList({
                period: Utils.periods.dayjsRangeToPeriodString([dayjs(params.From), dayjs(params.To).subtract(1, 'ms')])
            }).then((r) => r.data.Data);
            const levelsReq = selectMainReportConfirmationLevels(getState())
                ?? dispatch(loadConfigurationConfirmationLevels())
                    .then((r) => r.Levels.MainReport);
            const response = await Promise.all([rawReportReq, workDaysReq, levelsReq]);
            const { report } = new MainReport({
                rawReport: response[0],
                workDaysData: response[1],
                levels: response[2]
            });
            dispatch(saveMainReport({ report, workDays: response[1] }));
        }
        catch (e) {
            console.error(e);
        }
    };
}
export function recalculateMainReport() {
    return async (dispatch, getState) => {
        try {
            const state = getState();
            const rawReport = selectCompletedWorkData(state);
            const workDaysData = selectWorkDays(state);
            const levels = selectMainReportConfirmationLevels(state);
            const { report } = new MainReport({
                rawReport,
                workDaysData,
                levels
            });
            dispatch(saveMainReport({ report, workDays: workDaysData }));
        }
        catch (e) {
            console.error(e);
        }
    };
}
